import Head from "next/head";

import { InfoPageContainer } from "../../constants/Styles";
import * as styledElements from "./ErrorComponentStyles";

const ErrorComponent = ({ smallTitle }: { smallTitle?: boolean }) => {
  return (
    <>
      <Head>
        <title>Sorry!</title>
        <meta name="description" content="Unexpected error occurred" />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <InfoPageContainer>
        <styledElements.Title smallTitle={smallTitle}>
          Sorry!
        </styledElements.Title>
        <styledElements.Description>
          An unexpected error occurred. Our team has been notified.
        </styledElements.Description>
        <styledElements.Description>
          Please reach out to{" "}
          <a href="mailto:help@flashpcb.com">help@flashpcb.com</a> if you have
          any specific questions or concerns.
        </styledElements.Description>
      </InfoPageContainer>
    </>
  );
};

export default ErrorComponent;
